import React from 'react';
import styled from 'styled-components';
import { apiState } from '../../Api';

interface Props {
  loadMore: () => void;
  loadState: apiState;
  height: string;
  carregouTodasOrientacoes: boolean
}

const StyledDiv = styled.div<{
  height: string
}>`
  max-height: ${props => props.height};
  overflow-y: scroll;
`;
interface State {
  loading: boolean,
  position: number
}
export const withPages = <P extends object>(Component: React.ComponentType<P>) =>
  class WithPages extends React.Component<P & Props, State> {
    ref: React.RefObject<HTMLDivElement>;

    constructor(args: any) {
      super(args);

      this.state = {
        loading: false,
        position: 0
      };

      this.ref = React.createRef();
    }

    componentDidUpdate() {
      if (apiState.done === this.props.loadState && this.state.loading) {
        this.ref.current && this.ref.current.scrollTo(0, this.state.position);
        this.setState({ loading: false });
      }
    }

    onScrollEvent = (e: any) => {
      if (e.target.scrollTop === (e.target.scrollHeight - e.target.clientHeight) && ![apiState.noContent, apiState.loading].includes(this.props.loadState)) {
        if (!this.props.carregouTodasOrientacoes) {
          this.props.loadMore();
        }
        this.setState({ loading: true, position: (e.target.scrollHeight - e.target.clientHeight) });
      }
    }

    render() {
      const { height } = this.props;

      return (
        <StyledDiv
          onScroll={this.onScrollEvent}
          ref={this.ref}
          height={height}
        >
          <Component
            {...this.props as P}
          />
        </StyledDiv>
      );
    }
  };

